import { useEffect, useRef, useState } from "react";
import * as d3 from "d3";
import ToolTip from "./ToolTip";

export default function VenueMap({ data: { venues, topography } }) {
  const mapRef = useRef();
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipData, setTooltipData] = useState({
    name: "",
    population: "",
    x: 0,
    y: 0,
  });
  const venuesList = ["Patna", "Bhagalpur", "Gaya", "Nalanda", "Begusarai"];
  useEffect(function () {
    const svg = d3
      .select(mapRef.current)
      .append("svg")
      .attr("viewBox", "0 0 400 280") // Set viewBox height to 250 and width to 400
      .attr("preserveAspectRatio", "xMidYMid meet") // Preserve aspect ratio
      .style("width", "90%") // Make it responsive to container width
      .style("max-width", "600px") // Set maximum width to 600px
      .style("height", "auto") // Adjust height automatically
      .style("display", "block")
      .style("margin", "0 auto")
      // .style("border", "1px solid black"); // Add 1px black border
    // .call(
    //   d3
    //     .drag()
    //     .on("start", function (event) {
    //       d3.select(this).style("cursor", "grabbing");
    //     })
    //     .on("drag", function (event) {
    //       const dx = event.dx;
    //       const dy = event.dy;
    //       const currentTransform =
    //         d3.select(this).attr("transform") || "translate(0,0)";
    //       const translate = currentTransform.match(/translate\(([^)]+)\)/);
    //       let [x, y] = translate
    //         ? translate[1].split(",").map(Number)
    //         : [0, 0];
    //       x += dx;
    //       y += dy;
    //       d3.select(this).attr("transform", `translate(${x},${y})`);
    //     })
    //     .on("end", function () {
    //       d3.select(this).style("cursor", "grab");
    //     })
    // )
    // .style("cursor", "grab");

    // Move legend to top right
    const legend = svg.append("g").attr("transform", "translate(290, 25)"); // Adjust position to top right

    const legendData = [
      { color: "#016938", label: "स्थल" },
      { color: "#f05623", label: "अन्य" },
    ];

    legendData.forEach((item, index) => {
      const legendItem = legend
        .append("g")
        .attr("transform", `translate(0, ${index * 20})`);

      legendItem
        .append("rect")
        .attr("width", 15)
        .attr("height", 15)
        .attr("fill", item.color)
        .attr("stroke", "black") // Add black border
        .attr("stroke-width", 1); // Set border width

      legendItem
        .append("text")
        .attr("x", 20)
        .attr("y", 12)
        .text(item.label)
        .style("font-size", "12px")
        .style("alignment-baseline", "middle");
    });
    const projection = d3
      .geoMercator()
      .scale(4200) // Further increase the scale to make the projection bigger
      .center([85.3131, 25.0961]) // Center the projection on Bihar
      .translate([160, 210]); // Adjust translation to keep it centered in the SVG

    const path = d3.geoPath().projection(projection);

    const g = svg.append("g");

    g.selectAll("path")
      .data(topography.features)
      .enter()
      .append("path")
      .attr("d", path)
      .attr(
        "fill",
        (d) => {
          if (venuesList.includes(d.properties.district)) return "#016938";
          else return "#f05623";
        }
        // "#" +
        // (((1 << 24) * Math.random()) | 0).toString(16).padStart(6, "0")
      )
      .attr("stroke", "#ff0")
      .on("mouseover", function (event, d) {
        d3.select(this).attr("fill", "orange");
        const [x, y] = d3.pointer(event, mapRef.current);
        //   setTooltipVisible(true);
        //   setTooltipData({
        // district: d.properties.district,
        // left: x,
        // top: y,
        //   });
      })
      .on("mouseout", function () {
        d3.select(this).attr(
          "fill",
          (d) => {
            if (venuesList.includes(d.properties.district)) return "#016938";
            else return "#f05623";
          }
          // "#" +
          // (((1 << 24) * Math.random()) | 0).toString(16).padStart(6, "0")
        );
        // d3.select(this).attr(
        //   "fill",
        //   "#" +
        //     (((1 << 24) * Math.random()) | 0).toString(16).padStart(6, "0")
        // );
        // setTooltipVisible(false);
      })
      .on("click", function (event, d) {
        d3.select(this).attr("fill", "orange");
        const [x, y] = d3.pointer(event, mapRef.current);
        // console.log("Coordinates:", x, y);
        // console.log("Venues:", venues[d.properties.district]);
        setTooltipVisible(true);
        setTooltipData({
          district: venues[d.properties.district]?.name,
          events: venues[d.properties.district]?.events,
          // left: svg.node().getBoundingClientRect().left,
          // top: svg.node().getBoundingClientRect().top,
          left: svg.node().getBoundingClientRect().left + window.scrollX,
          top: svg.node().getBoundingClientRect().top + window.scrollY,
          // left: x,
          // top: event.pageY,
          // top: y,
          // top: event.offsetY,
        });
      })
      .attr("stroke-width", 1)
      .append("title")
      .text((d) => venues[d.properties.district]?.name);

    // Add zoom and drag behavior
    const zoom = d3.zoom().on("zoom", (event) => {
      g.attr("transform", event.transform);
    });

    // svg.call(zoom);
  }, []);
  return (
    <>
      <div ref={mapRef}>
        <ToolTip
          tooltipData={tooltipData}
          tooltipVisible={tooltipVisible}
          setTooltipVisible={setTooltipVisible}
        />
      </div>
    </>
  );
}
